/* HdL: adds captions (from the Video captions metaobjects) to any video on the page, a CC toggle on videos without native controls,
   and a Sound button on muted videos that have audio but no controls (UGC sliders and Instafeed have their own). */
(function () {
  var el = document.getElementById('hdl-video-captions');
  var map = {};
  try { map = el ? JSON.parse(el.textContent) : {}; } catch (e) { map = {}; }
  var urls = {};
  var RX = /videos\/c\/(?:vp|o\/v)\/([0-9a-f]{32})/;
  function hashOf(v) {
    var list = [v.currentSrc, v.getAttribute('src')];
    v.querySelectorAll('source').forEach(function (s) { list.push(s.getAttribute('src')); });
    for (var i = 0; i < list.length; i++) { var m = (list[i] || '').match(RX); if (m) return m[1]; }
    return null;
  }
  function vttUrl(h) {
    if (!urls[h]) {
      var e = map[h]; var t = String((e && typeof e === 'object') ? e.v : (e || '')).trim();
      if (!/^WEBVTT/.test(t)) t = 'WEBVTT\n\n' + t;
      urls[h] = URL.createObjectURL(new Blob([t + '\n'], { type: 'text/vtt' }));
    }
    return urls[h];
  }
  function addToggle(v, track) {
    var box = v.parentElement;
    if (!box || box.querySelector(':scope > .hdl-cc')) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hdl-cc';
    b.textContent = 'CC';
    b.setAttribute('aria-label', 'Captions');
    b.setAttribute('aria-pressed', track.__hdlOn ? 'true' : 'false');
    ['click', 'pointerdown', 'touchstart'].forEach(function (ev) {
      b.addEventListener(ev, function (e) {
        e.stopPropagation();
        if (ev !== 'click') return;
        e.preventDefault();
        var nowOn = track.track.mode !== 'showing';
        track.track.mode = nowOn ? 'showing' : 'hidden';
        if (track.track.cues) [].forEach.call(track.track.cues, function (c) { c.line = -4; });
        b.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
      }, true);
    });
    box.appendChild(b);
  }
  function hasAudio(v) {
    if (v.audioTracks) return v.audioTracks.length > 0;
    if (typeof v.mozHasAudio === 'boolean') return v.mozHasAudio;
    return (v.webkitAudioDecodedByteCount || 0) > 0;
  }
  function addSound(v) {
    if (v.__hdlSnd || v.controls) return;
    if (v.closest('[id*="instafeed"], .videotestimonialwrapper')) return;
    v.__hdlSnd = true;
    var check = function () {
      if (v.currentTime < 0.8) return;
      v.removeEventListener('timeupdate', check);
      if (!hasAudio(v)) return;
      var box = v.parentElement;
      if (!box || box.querySelector(':scope > .hdl-snd')) return;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hdl-snd';
      var label = function () { b.textContent = v.muted ? 'Sound on' : 'Mute'; b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Mute video'); };
      label();
      ['pointerdown', 'touchstart'].forEach(function (ev) { b.addEventListener(ev, function (e) { e.stopPropagation(); }, true); });
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; if (!v.muted && v.paused) v.play(); label(); }, true);
      v.addEventListener('volumechange', label);
      box.appendChild(b);
    };
    v.addEventListener('timeupdate', check);
  }
  function apply(v) {
    addSound(v);
    var h = hashOf(v);
    if (!h || !map[h]) return;
    if (v.__hdlCap || v.querySelector('track[data-hdl-cap]')) { v.querySelectorAll('track[data-hdl-cap]').forEach(function (t, i) { if (i > 0) t.remove(); }); var ex = v.querySelector('track[data-hdl-cap]'); if (ex && !v.controls) addToggle(v, ex); return; }
    v.__hdlCap = true;
    var on = !(map[h] && typeof map[h] === 'object' && map[h].on === false);
    var tr = document.createElement('track');
    tr.kind = 'captions';
    tr.srclang = 'en';
    tr.label = 'English';
    tr.setAttribute('data-hdl-cap', '');
    tr.__hdlOn = on;
    if (on) tr.default = true;
    tr.src = vttUrl(h);
    v.appendChild(tr);
    var show = function () {
      try {
        tr.track.mode = on ? 'showing' : 'hidden';
        if (tr.track.cues) [].forEach.call(tr.track.cues, function (c) { c.line = -4; });
      } catch (e) {}
    };
    show();
    tr.addEventListener('load', show);
    if (!v.controls) addToggle(v, tr);
  }
  function scan(root) { (root.querySelectorAll ? root : document).querySelectorAll('video').forEach(apply); }
  scan(document);
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'VIDEO') apply(n); else if (n.querySelectorAll) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('loadedmetadata', function (e) { if (e.target.tagName === 'VIDEO') apply(e.target); }, true);
})();
